module.exports = __webpack_public_path__ + "static/media/placeholder.356df3ce.svg";